import type { CSSProperties } from "react";

import { cn } from "../../lib/cn.js";

import type {
  DataTableAlignment,
  DataTableColumn,
  DataTableColumnSlot,
} from "./DataTable.types.js";

const ALIGNMENT_CLASS_NAMES: Record<DataTableAlignment, string> = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
};

export function getDataTableColumnClassName<T>(
  column: DataTableColumn<T>,
  slot: DataTableColumnSlot,
): string {
  return cn(
    column.className,
    slot === "header" ? column.headerClassName : column.cellClassName,
    column.align ? ALIGNMENT_CLASS_NAMES[column.align] : undefined,
  );
}

export function getDataTableColumnStyle<T>(column: DataTableColumn<T>): CSSProperties | undefined {
  if (column.width === undefined) return undefined;

  return {
    width: typeof column.width === "number" ? `${column.width}px` : column.width,
  };
}
